import { Component, inject, Input, OnDestroy } from '@angular/core';
import { PopupService } from '@app/shared/services/popup.service';
import { DismissedPopupKeywords } from '@isophi/core-legacy';

@Component({
    selector: 'app-innitial-popup',
    templateUrl: './innitial-popup.component.html',
    styleUrls: ['./innitial-popup.component.scss'],
    standalone: false
})
export class InnitialPopupComponent implements OnDestroy {
  private readonly popupService = inject(PopupService);

  @Input() popupKey: DismissedPopupKeywords;

  dontShowAgain = false;

  close(): void {
    this.popupService.closePopup(this.popupKey);
  }

  ngOnDestroy(): void {
    if (this.dontShowAgain) {
      this.popupService.dismissPopup(this.popupKey);
    }
    this.popupService.closePopup(this.popupKey, true);
  }
}
